import type { BulkJob } from '../../../../Types/accountQuery';
import { accountEditExceptions, accountEditLabel, accountEditPending } from '../../../Account/accountEditStatus';
import { NotificationCard } from './NotificationCard';

export function AccountEditNotification({ job, onClose, onReview }: {
  job: BulkJob;
  onClose: () => void;
  onReview: () => void;
}) {
  const pending = accountEditPending(job);
  const exceptions = accountEditExceptions(job) > 0;
  return <NotificationCard
    title={accountEditLabel(job)}
    description={`${accountEditLabel(job)} requested for ${job.count.toLocaleString()} accounts. You can keep working.`}
    icon={<i className="fa-duotone fa-solid fa-info-circle" />}
    variant="alert-default"
    onDismiss={onClose}
    dismissLabel="Dismiss account edit message"
    role="status"
    autoDismissMs={6000}
    action={<button type="button" className="alert-review" onClick={onReview}>{pending ? 'View progress' : exceptions ? 'Review results' : 'View results'}</button>}
  />;
}
